export default __webpack_public_path__ + "static/move-c1c4bcf34fca509740eab8916606cc9a.png";